// HM-332 placeholder cluster 16 - implementazione completa in iterazioni
// successive (anagrafica + logo + parametri fiscali).

import { Placeholder } from './_Placeholder.js';

export function HotelSection() {
  return <Placeholder title="Hotel" hint="Anagrafica struttura, logo, parametri fiscali" />;
}
